import { cn } from '@/lib/utils'

interface ProgressiveBlurProps {
  direction?: 'left' | 'right' | 'top' | 'bottom'
  blurIntensity?: number
  className?: string
}

export function ProgressiveBlur({
  direction = 'left',
  blurIntensity = 1,
  className,
}: ProgressiveBlurProps) {
  const gradientMap = {
    left: 'to right',
    right: 'to left',
    top: 'to bottom',
    bottom: 'to top',
  }

  const layers = 6
  const steps = Array.from({ length: layers }, (_, i) => {
    const t = i / (layers - 1)
    const blur = blurIntensity * t * t * 8
    const opacity = 1 - t
    return { blur, opacity }
  })

  return (
    <div className={cn('pointer-events-none', className)} aria-hidden>
      {steps.map((s, i) => (
        <div
          key={i}
          className="absolute inset-0"
          style={{
            backdropFilter: `blur(${s.blur}px)`,
            WebkitBackdropFilter: `blur(${s.blur}px)`,
            maskImage: `linear-gradient(${gradientMap[direction]}, transparent ${(i / layers) * 100}%, black ${((i + 1) / layers) * 100}%)`,
            WebkitMaskImage: `linear-gradient(${gradientMap[direction]}, transparent ${(i / layers) * 100}%, black ${((i + 1) / layers) * 100}%)`,
          }}
        />
      ))}
    </div>
  )
}
